import { UserOperationTypes } from "../../common/types/AuthorizationProps";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import Filters from "../components/FreePayment/Filters";
import PageTitle from "../components/PageTitle";
export default function CreateFreePayment() {
  usePermissionCheck(UserOperationTypes["Ödeme Linki Gönder"], "Ödeme Linki İşlemleri izni yok");
  return (
    <div className="w-full">
      <PageTitle title={pageTitleTexts.createFreePayment} />
      <div className="px-4 py-2 flex flex-col justify-start space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/serbest-odeme-baslat-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Serbest Ödeme Başlat
          </span>
        </div>
      </div>
      <Filters />
    </div>
  );
}
